module.exports = "/_next/static/images/clear-drops-2a995ff35daa1756a54dfe951e895ee4.png";